module.exports = __webpack_public_path__ + "img/twitter-icon.d03938b4.svg";